export const TOKEN='skladToken';
